import { render, staticRenderFns } from "./aiTutor.vue?vue&type=template&id=04a011f7"
import script from "./aiTutor.vue?vue&type=script&lang=js"
export * from "./aiTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports